// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__39HxV","HeaderLogo":"Header_HeaderLogo__2c9vc","HeaderImage":"Header_HeaderImage__3kJ8m"};